import { render, staticRenderFns } from "./SececondaryGuardians.vue?vue&type=template&id=b847e974"
import script from "./SececondaryGuardians.vue?vue&type=script&lang=js"
export * from "./SececondaryGuardians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports